import { ViewSwitcher } from "features/data-management/workspace/workspace/body/navigation-bar/breadcrumb-bar/view-switcher/ViewSwitcher"
import * as Icons from "@nova/component-icons"

type PreviewFilesViewSwitcherProps = {
    viewMode: "List" | "Grid"
    setViewMode: (mode: "List" | "Grid") => void
}
export const PreviewFilesViewSwitcher = ({
    viewMode,
    setViewMode,
}: PreviewFilesViewSwitcherProps) => {
    return (
        <div className="flex justify-between items-center text-gray-300 border-b border-t border-gray-700 py-2 px-0.5">
            <h5 className="text-gray-100 mr-[7rem] w-max">View By</h5>
            <ViewSwitcher
                firstOption={{
                    icon: Icons.Grid,
                    isSelected: viewMode === "Grid",
                    onSwitch: () => setViewMode("Grid"),
                }}
                secondOption={{
                    icon: Icons.List,
                    isSelected: viewMode === "List",
                    onSwitch: () => setViewMode("List"),
                }}
                title=""
            />
        </div>
    )
}
